module.exports = __webpack_public_path__ + "static/media/032.bd989cd9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/products/normals/032.jpg
// module id = 505
// module chunks = 0